import React from "react";
var __jsx = React.createElement;
import { TypePriceOfferStepEnum, usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import { useEffect, useMemo } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import Loader from "@componentsShared/Loader/Loader";
import useHelpers from "@hooks/useHelpers";
import PriceOfferOfferPage from "@/pages/price-offer/PriceOfferOfferPage";
import PriceOfferExpiredPage from "@/pages/price-offer/PriceOfferExpiredPage";
import PriceOfferSubmittedPage from "@/pages/price-offer/PriceOfferSubmittedPage";
import PriceOfferSuccessPage from "@/pages/price-offer/PriceOfferSuccessPage";
import PriceOfferRejectedPage from "@/pages/price-offer/PriceOfferRejectedPage";
import PriceOfferInspectionLocationPage from "@/pages/price-offer/PriceOfferInspectionLocationPage";
import PriceOfferInspectionUserLocation from "@/pages/price-offer/PriceOfferInspectionUserLocation";
import PriceOfferInspectionDatePage from "@/pages/price-offer/PriceOfferInspectionDatePage";
import PriceOfferInspectionSuccessPage from "@/pages/price-offer/components/PriceOfferInspectionSuccessPage";
import PriceOfferInspectionLocationSinglePage from "@/pages/price-offer/PriceOfferInspectionLocationSinglePage";
import PriceOfferDesktopLayout from "@/pages/price-offer/components/PriceOfferDesktopLayout";
import PriceOfferRejectPage from "@/pages/price-offer/PriceOfferRejectPage";
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import SyarahLogoLottie from "@/components/SyarahLogoLottie/SyarahLogoLottie";
var PriceOfferFlowPage = function PriceOfferFlowPage() {
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _usePriceOfferContext = usePriceOfferContext(),
    state = _usePriceOfferContext.state,
    remote_actions = _usePriceOfferContext.remote_actions,
    constants = _usePriceOfferContext.constants,
    helpers = _usePriceOfferContext.helpers;
  var offerData = state === null || state === void 0 ? void 0 : state.offerData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    //@TODO: navigate user to home if no offer_expiry_date is present
    if (helpers.checkRequestExpiry()) {
      navigateTo(constants.expired_url(state === null || state === void 0 ? void 0 : state.request_id));
    } else if (helpers.checkRequestAlreadyProcessed()) {
      navigateTo(constants.submitted_url(state === null || state === void 0 ? void 0 : state.request_id));
    }
  }, [offerData, state === null || state === void 0 ? void 0 : state.request_id]);
  var haveMobileHeader = useMemo(function () {
    var match = [TypePriceOfferStepEnum.inspection_success, TypePriceOfferStepEnum.success, TypePriceOfferStepEnum.submitted, TypePriceOfferStepEnum.rejected, TypePriceOfferStepEnum.expired].includes(state === null || state === void 0 ? void 0 : state.step);
    return !match;
  }, [state === null || state === void 0 ? void 0 : state.step]);
  var renderMobileHeader = useMemo(function () {
    if (!haveMobileHeader) return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid"
    }, /*#__PURE__*/React.createElement(SyarahLogoLottie, {
      width: 56,
      alt: "syarah logo icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "w-4 h-4"
    })));
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid"
    }, /*#__PURE__*/React.createElement("div", {
      className: "en:transform en:rotate-180",
      onClick: function onClick() {
        if ((state === null || state === void 0 ? void 0 : state.step) === TypePriceOfferStepEnum.inspection_location || (state === null || state === void 0 ? void 0 : state.step) === TypePriceOfferStepEnum.inspection_location_single || (state === null || state === void 0 ? void 0 : state.step) === TypePriceOfferStepEnum.inspection_user_location) {
          navigateTo(constants.offer_url(state === null || state === void 0 ? void 0 : state.request_id));
        } else {
          history.back();
        }
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--arrow-forward-ios-rounded",
      width: 4,
      height: 4,
      className: "text-[#3c56d4]"
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-sm flex items-center text-primary font-bold m-auto"
    }, t("car_purchase_price_offer", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("div", {
      className: "w-4 h-4"
    })));
  }, [t, haveMobileHeader]);
  var renderStepContent = useMemo(function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (state === null || state === void 0 ? void 0 : state.step) === "offer" && /*#__PURE__*/React.createElement(PriceOfferOfferPage, null), (state === null || state === void 0 ? void 0 : state.step) === "submitted" && /*#__PURE__*/React.createElement(PriceOfferSubmittedPage, null), (state === null || state === void 0 ? void 0 : state.step) === "success" && /*#__PURE__*/React.createElement(PriceOfferSuccessPage, null), (state === null || state === void 0 ? void 0 : state.step) === "rejected" && /*#__PURE__*/React.createElement(PriceOfferRejectedPage, null), (state === null || state === void 0 ? void 0 : state.step) === "reject" && /*#__PURE__*/React.createElement(PriceOfferRejectPage, null), (state === null || state === void 0 ? void 0 : state.step) === "expired" && /*#__PURE__*/React.createElement(PriceOfferExpiredPage, null), (state === null || state === void 0 ? void 0 : state.step) === "inspection_location" && /*#__PURE__*/React.createElement(PriceOfferInspectionLocationPage, null), (state === null || state === void 0 ? void 0 : state.step) === "inspection_location_single" && /*#__PURE__*/React.createElement(PriceOfferInspectionLocationSinglePage, null), (state === null || state === void 0 ? void 0 : state.step) === "inspection_user_location" && /*#__PURE__*/React.createElement(PriceOfferInspectionUserLocation, null), (state === null || state === void 0 ? void 0 : state.step) === "inspection_date" && /*#__PURE__*/React.createElement(PriceOfferInspectionDatePage, null), (state === null || state === void 0 ? void 0 : state.step) === "inspection_success" && /*#__PURE__*/React.createElement(PriceOfferInspectionSuccessPage, null));
  }, [state === null || state === void 0 ? void 0 : state.step]);
  if (!(state !== null && state !== void 0 && state.offerData)) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    mobileNoLogo: true,
    hideHeaderOnmobile: true,
    custommobileHeader: renderMobileHeader,
    hideFooterWithoutAuthMsg: true,
    authenticationMsg: true,
    hideBurgerMenu: true,
    hideAppBanner: true
  }, /*#__PURE__*/React.createElement(PriceOfferDesktopLayout, null, renderStepContent)));
};
export default PriceOfferFlowPage;